
export default {
    name: 'EmbeddedVideoSection',
    props: {
        blok: {
            type: Object,
            required: true
        }
    }
}
